import React from "react";
import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import loanFormActions from "@redux/loanForm/actions";
import { useFormButtonContext } from "../../context/formContext/submitButton";
import { ErrorFocus } from "./errorFocus";
import { useOnMount } from "@hooks";

const RenderForm = ({formProps, route, step, setSubmitForm}) => {
  useOnMount(() => {
    setSubmitForm(() => formProps.submitForm);
  });
  return (
    <>
      <route.component  {...formProps} step={step}/>
      <ErrorFocus />
    </>
  );
};

export const RenderFormStep = (props) => {
  const { route, setSubmitForm } = props;
  const { meta = {} } = route;
  const { validationSchema } = meta;

  const { initialValue, step } = useSelector(state => state.loanForm);
  const { queryString } = useSelector(state => state.StartUp);
  const dispatch = useDispatch();
  const { getOnSubmit } = useFormButtonContext();
  
  const handleSubmit = (values, actions) => {
    const onSubmit = getOnSubmit();
    const shouldCancelSubmit = !onSubmit();
    if (shouldCancelSubmit) {
      return;
    }
    
    const { setSubmitting } = actions;
    setSubmitting(true);
    try {
      setSubmitting(false);
      dispatch(loanFormActions.postLoanFormRequest({ values, step, queryString }));
    } catch (err) {
      console.log(err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Formik
      initialValues={initialValue}
      validationSchema={validationSchema}
      enableReinitialize
      validateOnChange
      validateOnBlur
      validateOnMount
      onSubmit={(values, actions) => handleSubmit(values, actions)}
    >
      {(formProps) => (
        <RenderForm formProps={formProps} setSubmitForm={setSubmitForm} step={step} route={route} />
      )}
    </Formik>
  );
};